var exports = {
  "gx": "NamePaint.module__font___eVU1Wn",
  "cz": "NamePaint.module__clipped___eVU1Wn",
  "D7": "NamePaint.module__gradient___eVU1Wn",
  "bc": "NamePaint.module__holographic___eVU1Wn",
  "iM": "NamePaint.module__shimmer___eVU1Wn",
  "ys": "NamePaint.module__glow___eVU1Wn",
  "eX": "NamePaint.module__nameHolographic___eVU1Wn",
  "X9": "NamePaint.module__nameShimmer___eVU1Wn",
  "lD": "NamePaint.module__nameGlow___eVU1Wn",
};

module.exports = exports;
